import React from "react";
import { motion } from "framer-motion";

/**
 * Reveal — wraps children and fades/slides them up as they enter the viewport.
 * Used to animate Home and PDP sections. Respects prefers-reduced-motion.
 */
const Reveal = ({ children, delay = 0, y = 24, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.18 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export default Reveal;
